import { OverlayContainer } from '@angular/cdk/overlay';
import { inject, Injectable, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MobileModeService {
  private readonly mobileAuthorizedRoute = ['/tablet', '/baggages', '/untagged-baggages/inventory'];

  readonly isMobileMode = signal(false);

  private readonly activatedRoute = inject(ActivatedRoute);

  private readonly router = inject(Router);

  private readonly overlayContainer = inject(OverlayContainer);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.process() && !this.mobileAuthorizedRoute.some((r: string) => this.router.url.startsWith(r))) {
          this.router.navigate(['/tablet'], { queryParams: { mobile: true } });
        }
      });

    this.process();
  }

  private process() {
    const isMobile = this.activatedRoute.snapshot.queryParamMap.get('mobile') === 'true';
    this.isMobileMode.set(isMobile);
    if (isMobile) {
      this.overlayContainer.getContainerElement().classList.add('mobile-mode-overlay');
    }

    return isMobile;
  }
}
